/* tslint:disable */
/* eslint-disable */
/**
 * Bioplan API
 * Backend API for Bioplan, an aquaculture production planning tool.
 *
 * Contact: support@optimeeringaqua.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type {Configuration} from '../configuration';
import type {AxiosPromise, AxiosInstance, RawAxiosRequestConfig} from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common';
// @ts-ignore
import {BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap} from '../base';
// @ts-ignore
import type {GlobalSettings} from '../bioplanModels';
/**
 * ModellingGlobalSettingsApi - axios parameter creator
 * @export
 */
export const ModellingGlobalSettingsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    globalSettingsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/globalSettings/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update default accumulated mortality rate for a tenant
     * @param {GlobalSettings} globalSettings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    globalSettingsPut: async (
      globalSettings: GlobalSettings,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'globalSettings' is not null or undefined
      assertParamExists('globalSettingsPut', 'globalSettings', globalSettings);
      const localVarPath = `/globalSettings/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'PUT', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(globalSettings, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ModellingGlobalSettingsApi - functional programming interface
 * @export
 */
export const ModellingGlobalSettingsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ModellingGlobalSettingsApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async globalSettingsGet(
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GlobalSettings>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.globalSettingsGet(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ModellingGlobalSettingsApi.globalSettingsGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update default accumulated mortality rate for a tenant
     * @param {GlobalSettings} globalSettings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async globalSettingsPut(
      globalSettings: GlobalSettings,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GlobalSettings>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.globalSettingsPut(globalSettings, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ModellingGlobalSettingsApi.globalSettingsPut']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * ModellingGlobalSettingsApi - factory interface
 * @export
 */
export const ModellingGlobalSettingsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = ModellingGlobalSettingsApiFp(configuration);
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    globalSettingsGet(options?: RawAxiosRequestConfig): AxiosPromise<GlobalSettings> {
      return localVarFp.globalSettingsGet(options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update default accumulated mortality rate for a tenant
     * @param {ModellingGlobalSettingsApiGlobalSettingsPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    globalSettingsPut(
      requestParameters: ModellingGlobalSettingsApiGlobalSettingsPutRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<GlobalSettings> {
      return localVarFp
        .globalSettingsPut(requestParameters.globalSettings, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for globalSettingsPut operation in ModellingGlobalSettingsApi.
 * @export
 * @interface ModellingGlobalSettingsApiGlobalSettingsPutRequest
 */
export interface ModellingGlobalSettingsApiGlobalSettingsPutRequest {
  /**
   *
   * @type {GlobalSettings}
   * @memberof ModellingGlobalSettingsApiGlobalSettingsPut
   */
  readonly globalSettings: GlobalSettings;
}

/**
 * ModellingGlobalSettingsApi - object-oriented interface
 * @export
 * @class ModellingGlobalSettingsApi
 * @extends {BaseAPI}
 */
export class ModellingGlobalSettingsApi extends BaseAPI {
  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ModellingGlobalSettingsApi
   */
  public globalSettingsGet(options?: RawAxiosRequestConfig) {
    return ModellingGlobalSettingsApiFp(this.configuration)
      .globalSettingsGet(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update default accumulated mortality rate for a tenant
   * @param {ModellingGlobalSettingsApiGlobalSettingsPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ModellingGlobalSettingsApi
   */
  public globalSettingsPut(
    requestParameters: ModellingGlobalSettingsApiGlobalSettingsPutRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ModellingGlobalSettingsApiFp(this.configuration)
      .globalSettingsPut(requestParameters.globalSettings, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
